import axios from 'axios';

const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL;
const auth = () => ({ headers: { accessToken: localStorage.getItem('accessToken') } });

export const fetchCommissionsReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/commissions`, {
    ...auth(),
    params,
  });
  return res.data; // { rows: [...] }
};

export const exportCommissionsCsv = async (params) => {
  return axios.get(`${BASE_URL}/reports/commissions/csv`, {
    ...auth(),
    params,
    responseType: 'blob',
  });
};

/**
 * Override commission for a single order (and save a note).
 * Server route should handle: POST /reports/commissions/:orderId/override
 * Payload example:
 *  {
 *    commissionable: 1234.56, // optional
 *    marginAmount: 789.01,    // optional
 *    overrideAmount: 250.00,  // optional
 *    note: "Manual adjustment for split order"
 *  }
 */
export const updateCommissionOverride = (orderId, payload) => {
  return axios.post(
    `${BASE_URL}/reports/commissions/${orderId}/override`,
    payload,
    auth()
  );
};

export const payCommissions = (payload) => axios.post(`${BASE_URL}/reports/commissions/pay`, payload, auth());
export const paySelectedCommissions = (payload) => axios.post(`${BASE_URL}/reports/commissions/pay-selected`, payload, auth());
export const unpayCommissions = (payload) => axios.post(`${BASE_URL}/reports/commissions/unpay`, payload, auth());

export const payCommissionsExportCsv = (payload) => axios.post(`${BASE_URL}/reports/commissions/pay`, { ...payload, exportCsv: true }, { ...auth(), responseType: 'blob' });
export const payCommissionsExportXlsx = (payload) => axios.post(`${BASE_URL}/reports/commissions/pay`, { ...payload, exportXlsx: true }, { ...auth(), responseType: 'blob' });

export const fetchCommissionReadinessPolicy = (instanceUniqueId) =>
  axios.get(`${BASE_URL}/reports/commissions/readiness-policy`, { ...auth(), params: { instanceUniqueId } });

export const updateCommissionReadinessPolicy = (instanceUniqueId, policy) =>
  axios.put(`${BASE_URL}/reports/commissions/readiness-policy`, { instanceUniqueId, policy }, auth());


export const fetchSalesReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/sales-rep`, { ...auth(), params });
  return res.data;
};

export const exportSalesCsv = async (params) => axios.get(`${BASE_URL}/reports/sales-rep.csv`, { ...auth(), params, responseType: 'blob' });

export const fetchSalesReportReps = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/sales-rep/reps`, { ...auth(), params });
  return res.data;
};


export const fetchDocumentReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/documents`, { ...auth(), params });
  return res.data;
};

export const exportDocumentCsv = async (params) =>
  axios.get(`${BASE_URL}/reports/documents.csv`, {
    ...auth(),
    params,
    responseType: 'blob',
  });


export const fetchProductSoldReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/product-sold`, { ...auth(), params });
  return res.data;
};

export const exportProductSoldCsv = async (params) =>
  axios.get(`${BASE_URL}/reports/product-sold.csv`, {
    ...auth(),
    params,
    responseType: 'blob',
  });

export const fetchSupplierReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/supplier`, { ...auth(), params });
  return res.data;
};

export const exportSupplierCsv = async (params) => axios.get(`${BASE_URL}/reports/supplier.csv`, { ...auth(), params, responseType: 'blob' });

export const fetchSupplierBillPipeline = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/supplier-bill-pipeline`, { ...auth(), params });
  return res.data;
};

export const exportSupplierBillPipelineCsv = (params) =>
  axios.get(`${BASE_URL}/reports/supplier-bill-pipeline.csv`, { ...auth(), params, responseType: 'blob' });

export const fetchClientInvoicingReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/client-invoicing`, { ...auth(), params });
  return res.data;
};

export const exportClientInvoicingCsv = async (params) =>
  axios.get(`${BASE_URL}/reports/client-invoicing.csv`, { ...auth(), params, responseType: 'blob' });

export const fetchWorkInProgressReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/work-in-progress`, { ...auth(), params });
  return res.data;
};

export const exportWorkInProgressCsv = async (params) =>
  axios.get(`${BASE_URL}/reports/work-in-progress.csv`, { ...auth(), params, responseType: 'blob' });

export const fetchWorkInProgressReportReps = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/work-in-progress/reps`, { ...auth(), params });
  return res.data;
};

export const fetchArAgingReport = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/ar-aging`, { ...auth(), params });
  return res.data;
};

export const exportArAgingCsv = async (params) =>
  axios.get(`${BASE_URL}/reports/ar-aging.csv`, { ...auth(), params, responseType: 'blob' });

export const fetchArAgingReportReps = async (params) => {
  const res = await axios.get(`${BASE_URL}/reports/ar-aging/reps`, { ...auth(), params });
  return res.data;
};

export const searchReportCustomers = async ({
  instanceUniqueId,
  q = '',
  page = 1,
  limit = 25,
}) => {
  const res = await axios.get(`${BASE_URL}/customers/get-customers`, {
    ...auth(),
    params: {
      instanceUniqueId,
      q,
      page,
      rpp: limit,
      tab: 'all',
    },
  });
  return res.data;
};

export const searchReportReps = async ({
  instanceUniqueId,
  q = '',
  page = 1,
  limit = 25,
  roles = [],
}) => {
  const res = await axios.get(`${BASE_URL}/reports/client-invoicing/reps`, {
    ...auth(),
    params: {
      instanceUniqueId,
      q,
      page,
      limit,
      roles,
    },
    paramsSerializer: {
      indexes: null,
    },
  });
  return res.data;
};
